import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { AreaContato } from "./area-contato.model";
import { apiName } from "./data.service";

@Injectable()
export class AreaContatoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: AreaContato, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: AreaContato, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"contato"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGet(apiName + '/' + objectId + '?', done);
  }

  onGetByArea(areaId: number, done: any) {
    var filter: any = {"order":"contato","where":{"areaId":areaId}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/area-contatos/area-contato-api.service.ts
 **/